export default {
  GET_ADMIN_DASHBOARD_DETAILS_REQUEST: "[adminDashboard] GET Admin Dashboard Details Request",
  SET_ADMIN_DASHBOARD_DETAILS: "[adminDashboard] SET Admin Dashboard Details",
  // INSERTION_PT (for script, do not remove)
};
